module.exports = __webpack_public_path__ + "static/colouring_in_petra-d15c45b302c65c28c48af7349c498850.pdf";